import { PRODUCT_ADD_SUCCESS, PRODUCT_ADD_FAILURE } from '../constants';
import { filter } from 'lodash';

export const addProduct = (userId, newProduct) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('users')
      .doc(userId)
      .update({
        products: firestore.FieldValue.arrayUnion({ ...newProduct })
      })
      .then(() => {
        dispatch({ type: PRODUCT_ADD_SUCCESS, payload: {} });
      })
      .catch(() => {
        dispatch({ type: PRODUCT_ADD_FAILURE, payload: {} });
      });
  };
};

export const removeProduct = (userId, productToRemove) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection('users')
      .doc(userId)
      .get()
      .then(userDoc => {
        const user = userDoc.data();
        const newProducts = filter(
          user.products,
          prod => prod.productName !== productToRemove.productName
        );
        userDoc.ref.update({
          products: newProducts
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/productActions.js